import { createSelector } from '@ngrx/store';

import { manageSurveyReferenceFeature } from './manage-survey-reference.feature';

const { selectManageSurveyReferenceState: selectManageSurveyReference } =
  manageSurveyReferenceFeature;

export const selectSupplierAllocations = createSelector(
  selectManageSurveyReference,
  ({ supplierAllocations }) => supplierAllocations,
);

export const selectSupplierAllocationsLoading = createSelector(
  selectManageSurveyReference,
  ({ supplierAllocationsLoading }) => supplierAllocationsLoading,
);

export const selectSupplierAllocationsError = createSelector(
  selectManageSurveyReference,
  ({ supplierAllocationsError }) => supplierAllocationsError,
);
